import React, { useState, useEffect } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Button,
  Grid,
  Typography,
  ListItem,
  IconButton,
  ListItemIcon,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AdjuntoComentario from "./AdjuntoComentario";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 6),
    borderRadius: "8px",
    outline: "none",
    width: "600px",
    overflowY: "auto", // Habilita el scroll vertical
    maxHeight: "90vh", // Limita la altura del contenedor
    padding: "16px", // Asegura un espacio adecuado
  },
  fileInput: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  btnAceptar: {
    backgroundColor: "#4d90fe",
    margin: "5px",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  btnCancelar: {
    backgroundColor: "gray",
    margin: "5px",
    color: "#000",
    "&:hover": {
      backgroundColor: "#CCCCCC",
    },
  },
  elementosAlFinal: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "flex-end",
  },
}));

const ViewAdjuntosComentario = ({
  modalViewAdjuntos,
  data,
  onClose,
  tarjeta,
  setCargando,
  setMensaje,
  setModalViewAdjuntos,
  getFileIcon,
}) => {
  const classes = useStyles();

  const handleIconClick = (archivo) => {
    if (archivo?.url) {
        // Crear un enlace temporal
        const link = document.createElement("a");
        link.href = archivo.url;
        link.target = "_blank"; // Especificar que se abra en una nueva pestaña
        document.body.appendChild(link);
        link.click(); // Simular clic para abrir el enlace
        document.body.removeChild(link); // Eliminar el enlace temporal
    }
  };

  return (
    <Modal
      open={Boolean(modalViewAdjuntos?.open)}
      onClose={onClose}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={Boolean(modalViewAdjuntos?.open)}>
        <Box
          className={classes.paper}
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography style={{ color: "#CCCCCC" }}>
                {"Archivos adjuntos de comentario"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                {modalViewAdjuntos?.open &&
                  data?.archivos?.map((file, index) => (
                    <Grid
                      item
                      key={index}
                      xs={3}
                      style={{
                        flex: "0 1 calc(20% - 12px)", // Cards más pequeñas (20% del ancho)
                        maxWidth: "calc(20% - 12px)", // Consistencia en el ancho
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Sombra más notable
                        backgroundColor: "#323940", // Fondo más oscuro
                        borderRadius: "6px", // Bordes redondeados más sutiles
                        padding: "12px", // Menor espaciado interno
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        margin: "5px",
                      }}
                    >
                      <ListItem
                        id={`btnArchivo${file?.idarchivo}`}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                          width: "100%",
                          height: "80px", // Altura más pequeña
                          borderRadius: "6px",
                          backgroundColor: "#424A54", // Fondo más claro para contraste
                        }}
                      >
                        {/* Ícono de archivo */}
                        <Tooltip title={file?.nombre || 'Sin nombre'}>
                          <IconButton
                            id={`btnDescargarArchivo${file?.idarchivo}`}
                            onClick={() => handleIconClick(file)}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <ListItemIcon
                              style={{
                                fontSize: "16px", // Ícono más pequeño
                                justifyContent: "center",
                                color: "#FFF", // Íconos en blanco para resaltar en el fondo oscuro
                              }}
                            >
                              {getFileIcon(file?.mimeType)}
                            </ListItemIcon>
                          </IconButton>
                        </Tooltip>
                      </ListItem>
                    </Grid>
                  ))}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.elementosAlFinal}>
            <Button
              variant="filled"
              onClick={() => setModalViewAdjuntos({ open: false })}
              className={classes.btnAceptar}
            >
              Cerrar
            </Button>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ViewAdjuntosComentario;
